import { Tooltip, withStyles } from '@material-ui/core';

const FlagMessageCopyLink = withStyles({
    tooltip: {
        color: '#1DA578',
        backgroundColor: '#D7F4E2',
        padding: '8px 16px',
        fontSize: '14px',
        boxShadow: '6px 5px 5px -4px rgba(0,0,0,0.3)'
    },
    arrow: {
        color: '#D7F4E2'
    }
})(Tooltip);

export default FlagMessageCopyLink;
